<template>
  <div class="containerRepresentante">
    <DeclaracoesDocumentosList
      :tipoClienteKey="user?.TipoCliente || TIPO_CLIENTE.PESSOA_JURIDICA"
      :showStatusButton="true"
      :showRefresh="true"
      :useImpressaoFlag="true"
    >
      <template #modals>
        <ModalInformativoDocumentosDeclaracoes_PJ_Fundos
          :guidDocumento="guidDocumento"
        />
        <ModalStatusAssinatura />
      </template>
    </DeclaracoesDocumentosList>
  </div>
</template>

<script>
import DeclaracoesDocumentosList from "@/components/Declaracoes/DeclaracoesDocumentosList.vue";
import ModalInformativoDocumentosDeclaracoes_PJ_Fundos from "../Documentos/ModalInformativoDocumentosDeclaracoes_PJ_Fundos.vue";
import ModalStatusAssinatura from "../Documentos/ModalStatusAssinaturaDeclaracoes_PJ_Fundos.vue";
import { mapGetters } from "vuex";
import { TIPO_CLIENTE } from "@/constants/TipoClienteEnum";

export default {
  name: "CadastroPF_Representantes",
  props: ["Edicao"],
  components: {
    DeclaracoesDocumentosList,
    ModalInformativoDocumentosDeclaracoes_PJ_Fundos,
    ModalStatusAssinatura,
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
  },
  data() {
    return {
      TIPO_CLIENTE,
      guidDocumento: "",
    };
  },
};
</script>

<style lang="scss" scoped></style>
